(() => {
  const siteName = "default-package";
  const htmlHasClass = (_class) => {
    return document.documentElement.classList.contains(_class);
  };
  const a = "is-active";
  const v = "is-visible";
  const f = "is-fixed";

  FUNCTIONS = {
    va: {
      pathname: location.pathname,
      isMobile: htmlHasClass("ua-mobile"),
      device: {
        desktop: 1024,
        sp: 768,
      },
      window: {
        width: window.innerWidth,
        height: window.innerHeight,
      },
      header: {
        desktop: 100,
        sp: 60,
      },
    },
    localDecision() {
      const regExp = new RegExp(
        `(test\\.${siteName}\\.connecty\\.co\\.jp|copre\\.jp|localhost|192\\.168\\.)`,
        "g"
      );
      return regExp.test(location.hostname);
    },
    localLoading() {
      // ローカル環境ならincludeをAjaxで読み込む
      const _this = this;
      const key = "inc_";
      let ajaxArray = [];
      let ajaxArrayList = [];
      let includeClass = document.querySelectorAll(`[class*="${key}"]`);

      includeClass.forEach((ele) => {
        let path = ele.innerHTML.split(" ")[1];
        ajaxArray.push(path);
      });

      if (ajaxArray.length) {
        ajaxArray.forEach((ele) => {
          let xhr = new XMLHttpRequest();
          let promise = new Promise((resolve, reject) => {
            xhr.onreadystatechange = function () {
              if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                  resolve(xhr.responseText);
                } else {
                  reject(xhr.statusText);
                }
              }
            };
          });
          xhr.open("GET", ele + ".html", true);
          xhr.send();
          ajaxArrayList.push(promise);
        });

        Promise.all(ajaxArrayList)
          .then((results) => {
            let regExp = new RegExp(key);

            results.forEach((ele) => {
              let classList = ele.split(/ |\"/g);
              let position;

              classList.forEach((ele2) => {
                if (ele2.match(regExp)) {
                  position = ele2;
                }
              });
              document.querySelectorAll("." + position).forEach((ele2) => {
                ele2.outerHTML = ele;
              });
              console.log("Succeeded to read the include file!:", position);
            });

            _this.loadDelayScript();
          })
          .catch((error) => {
            console.error("Failed to read the include file:", error);
            _this.loadDelayScript();
          });
      } else {
        _this.loadDelayScript();
      }
    },
    getQuery() {
      let vars = [];
      let hash = null;
      let hashes = window.location.href
        .slice(window.location.href.indexOf("?") + 1)
        .split("&");
      hashes.forEach((ele) => {
        hash = ele.split("=");
        hash[1] = hash[1].indexOf("#") !== -1 ? hash[1].split("#")[0] : hash[1];
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
      });
      return vars;
    },
    accordion() {
      const details = document.querySelectorAll(".js-accordion");

      details.forEach((ele) => {
        const summary = ele.querySelector("summary");
        const wrapper = ele.querySelector(".mod-accordion-wrapper");
        const plus = ele.querySelector(".mod-accordion-plus");
        summary.addEventListener("click", (e) => {
          e.preventDefault();
          if (ele.open) {
            const close = wrapper.animate(
              {
                opacity: [1, 0],
                height: [wrapper.offsetHeight + "px", 0],
              },
              {
                duration: 300,
                easing: "ease",
              }
            );
            plus.animate(
              { rotate: ["90deg", "0deg"] },
              {
                duration: 300,
                pseudoElement: "::after",
                easing: "ease",
                fill: "forwards",
              }
            );
            close.onfinish = () => {
              ele.removeAttribute("open");
            };
          } else {
            ele.setAttribute("open", "true");
            wrapper.animate(
              {
                opacity: [0, 1],
                height: [0, wrapper.offsetHeight + "px"],
              },
              {
                duration: 300,
                easing: "ease",
              }
            );
            plus.animate(
              { rotate: ["0deg", "90deg"] },
              {
                duration: 300,
                pseudoElement: "::after",
                easing: "ease",
                fill: "forwards",
              }
            );
          }
        });
      });
    },
    tabSwitch() {
      let $tab = document.querySelectorAll(".js-tab");
      let $content = document.querySelectorAll(".js-tab-content");
      if ($tab.length) {
        // ハッシュタグで絞り込み
        if (location.hash) {
          let hash = location.hash.split("#")[1];
          $tab.forEach((ele) => {
            ele.classList.remove(a);
            if (ele.getAttribute("data-target").match(hash)) {
              ele.classList.remove(a);
            }
          });
          $content.forEach((ele) => {
            ele.classList.remove(a);
            ele.classList.remove(v);
            if (ele.getAttribute("data-target").match(hash)) {
              $(ele).addClass(a);
              setTimeout(() => {
                ele.classList.add(v);
              }, 200);
            }
          });
        }

        $tab.forEach((ele) => {
          ele.addEventListener("click", () => {
            $tab.forEach((ele2) => {
              ele2.classList.remove(a);
            });
            ele.classList.add(a);
            $content.forEach((ele) => {
              ele.classList.remove(a);
              ele.classList.remove(v);
            });

            let $target;
            let target = ele.getAttribute("data-target");
            if (target === "all") {
              $target = $content;
            } else {
              $target = document.querySelectorAll(
                '[data-target="' + target + '"]'
              );
            }
            $target.forEach((ele) => {
              ele.classList.add(a);
              setTimeout(() => {
                ele.classList.add(v);
              }, 200);
            });
          });
        });
      }
    },
    easeScroll() {
      const scrollToObject = (_self) => {
        let hash = _self.currentTarget.href.split("#")[1];
        let pos =
          hash === "pagetop"
            ? 0
            : document.getElementById(hash).getBoundingClientRect().top;
        let offset = hash === "pagetop" ? 0 : window.scrollY;
        pos += offset;

        if (hash !== "pagetop") {
          if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
            pos = pos - FUNCTIONS.va.header.sp;
          } else {
            pos = pos - FUNCTIONS.va.header.desktop;
          }
        }
        window.scrollTo({ top: pos, behavior: "smooth" });
      };
      // フォーカス用関数
      const scrollFocus = (_hash) => {
        let hash = _hash;
        if (hash !== "pagetop") {
          const focusableElementsSelector =
            'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
          const focusableElements = Array.from(
            document
              .getElementById(hash)
              .querySelectorAll(focusableElementsSelector)
          );
          if (focusableElements.length) {
            focusableElements[0].focus({ preventScroll: true });
          }
        }
      };
      // スクロール完了後に実行する関数
      let scrollResolveTimeout;
      const waitForScrollComplete = (_hash) => {
        return new Promise((resolve) => {
          const scrollTimeout = setTimeout(() => {
            resolve(true);
          }, 100);
          const scrollTimeoutEvent = addEventListener("scroll", function fn(e) {
            clearTimeout(scrollTimeout);
            clearTimeout(scrollResolveTimeout);
            scrollResolveTimeout = setTimeout(function () {
              scrollFocus(_hash);
              removeEventListener("scroll", fn);
              resolve(true);
            }, 100);
          });
        });
      };
      document.querySelectorAll('a[rel="scroll"]').forEach((ele) => {
        ele.addEventListener("click", async (e) => {
          e.preventDefault();
          if (/#/.test(e.currentTarget.href)) {
            scrollToObject(e);
            let hash = e.currentTarget.href.split("#")[1];
            await waitForScrollComplete(hash);
            return false;
          }
        });
      });
    },
    easeScrollHash() {
      const hash = location.hash;
      if (hash) {
        // フォーカス用関数
        const scrollFocus = (_hash) => {
          let hash = _hash;
          if (hash !== "pagetop") {
            const focusableElementsSelector =
              'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
            const focusableElements = Array.from(
              document
                .getElementById(hash)
                .querySelectorAll(focusableElementsSelector)
            );
            if (focusableElements.length) {
              focusableElements[0].focus();
            }
          }
        };
        // スクロール完了後に実行する関数
        let scrollResolveTimeout;
        const waitForScrollComplete = (_hash) => {
          return new Promise((resolve) => {
            const scrollTimeout = setTimeout(() => {
              resolve(true);
            }, 100);
            const scrollTimeoutEvent = addEventListener(
              "scroll",
              function fn(e) {
                clearTimeout(scrollTimeout);
                clearTimeout(scrollResolveTimeout);
                scrollResolveTimeout = setTimeout(function () {
                  scrollFocus(_hash);
                  removeEventListener("scroll", fn);
                  resolve(true);
                }, 100);
              }
            );
          });
        };
        window.addEventListener("load", async () => {
          document.documentElement.style.display = "none";
          document.body.style.display = "none";

          setTimeout(() => {
            document.documentElement.style.display = "block";
            document.body.style.display = "block";

            let pos = document
              .getElementById(hash.split("#")[1])
              .getBoundingClientRect().top;

            if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
              pos -= FUNCTIONS.va.header.sp;
            } else {
              pos -= FUNCTIONS.va.header.desktop;
            }
            window.scrollTo({ top: pos, behavior: "smooth" });
          }, 100);
          await waitForScrollComplete(hash);
        });
      }
    },
    pageTop() {
      let footer = document.querySelector(".footer");
      let $pagetop = document.querySelector(".footer-pagetop");

      if ($pagetop) {
        window.addEventListener("scroll", (e) => {
          if (window.scrollY > "100") {
            $pagetop.classList.add(v);
          } else {
            $pagetop.classList.remove(v);
          }
        });
      }
    },
    footerAccordion() {
      document.querySelectorAll(".js-footerAccordion").forEach((accordion) => {
        accordion.addEventListener("click", (e) => {
          const target = e.currentTarget;
          target.classList.toggle(a);
          const nextUl = target.parentElement.nextElementSibling;
          if (nextUl && nextUl.tagName.toLowerCase() === "ul") {
            nextUl.classList.toggle(a);
          }
        });
      });
    },
    setModal() {
      const createModal = (_appendHTML, _target) => {
        const $container = document.createElement("div");
        $container.className = "mod-modal-overlay";
        $container.innerHTML = _appendHTML;
        document.body.appendChild($container);

        $container.classList.add(a);
        setTimeout(() => {
          $container.classList.add(v);
          document
            .querySelectorAll(
              ".mod-modal-closeArea, .mod-modal-closeBtn, .mod-modalContent a"
            )
            .forEach((ele) => {
              ele.addEventListener("click", (e) => {
                $container.classList.remove(v);
                setTimeout(() => {
                  $container.classList.remove(a);
                  $container.remove();
                  _target.focus();
                }, 400);
              });
            });
          window.addEventListener("keydown", function (event) {
            if (document.querySelectorAll(".mod-modal-overlay").length) {
              // タブキーが押された時
              if (event.key === "Tab") {
                event.preventDefault();
                // モーダル要素内のフォーカス可能な要素の一覧を取得
                const focusableElementsSelector =
                  'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
                const focusableElements = Array.from(
                  document
                    .querySelector(".mod-modal-overlay")
                    .querySelectorAll(focusableElementsSelector)
                );
                // 現在のフォーカス位置を取得
                const focusedItemIndex = focusableElements.indexOf(
                  document.activeElement
                );
                // shiftキーと同時に押されてた場合
                if (event.shiftKey) {
                  if (focusedItemIndex === 0) {
                    // 現在のフォーカスが最初の要素の場合、最後の要素にフォーカスを移動
                    focusableElements[focusableElements.length - 1].focus();
                  } else {
                    // 現在のフォーカスが最初の要素以外の場合、前の要素にフォーカスを移動
                    focusableElements[focusedItemIndex - 1].focus();
                  }
                } else {
                  if (focusedItemIndex === focusableElements.length - 1) {
                    // 現在のフォーカスが最後の要素の場合、最初の要素にフォーカスを移動
                    focusableElements[0].focus();
                  } else {
                    // 現在のフォーカスが最後の要素以外の場合、次の要素にフォーカスを移動
                    focusableElements[focusedItemIndex + 1].focus();
                  }
                }
              }
              // ESCキーが押された時
              if (event.key === "Escape") {
                event.preventDefault();
                $container.classList.remove(v);
                setTimeout(() => {
                  $container.classList.remove(a);
                  $container.remove();
                  _target.focus();
                }, 400);
              }
            }
          });
        });
      };
      document.querySelectorAll(".mod-modal").forEach((ele) => {
        ele.addEventListener("click", (e) => {
          let targetKey = e.currentTarget.getAttribute("data-target");
          let $content = document.querySelector(
            `.mod-modalContent[data-target="${targetKey}"]`
          );
          if ($content) {
            let closeButton = document.createElement("button");
            closeButton.setAttribute("type", "button");
            closeButton.className = "mod-modal-closeBtn";
            closeButton.setAttribute("aria-label", "close");
            closeButton.innerHTML = '<span aria-hidden="true"></span>';

            $content.appendChild(closeButton);

            let closeArea = document.createElement("div");
            closeArea.className = "mod-modal-closeArea";
            let containerDiv = document.createElement("div");
            containerDiv.appendChild(closeArea);
            containerDiv.appendChild($content.cloneNode(true));

            createModal(containerDiv.innerHTML, e.currentTarget);
          }
          return false;
        });
      });

      // 画像1個だけのモーダル
      document.querySelectorAll(".mod-modalImg").forEach((ele) => {
        ele.addEventListener("click", (e) => {
          let appendHTML = `<div class="mod-modal-closeArea"></div>
						<button type="button" class="mod-modal-closeBtn" aria-label="close"><span aria-hidden="true"></span></button>
						${e.currentTarget.querySelector("img").outerHTML}`;
          createModal(appendHTML, e.currentTarget);
          return false;
        });
      });
    },
    matchHeight() {
      const $elements = document.querySelectorAll("[data-mh]");
      const groups = new Map();

      $elements.forEach((ele) => {
        ele.style.height = "auto";
      }); // 初期化

      $elements.forEach((ele) => {
        const attributeName = ele.getAttribute("data-mh");
        if (!groups.has(attributeName)) {
          groups.set(attributeName, []);
        }
        groups.get(attributeName).push(ele);
      });
      groups.forEach((group) => {
        const attributeGroups = new Map();
        group.forEach((ele) => {
          const attributeName = ele.getAttribute("data-mh");
          const topPosition = ele.getBoundingClientRect().top;
          const key = attributeName + "_" + topPosition;
          if (!attributeGroups.has(key)) {
            attributeGroups.set(key, []);
          }
          attributeGroups.get(key).push(ele);
        });
        attributeGroups.forEach((item) => {
          const maxHeight = Math.max(...item.map((ele) => ele.offsetHeight));
          item.forEach((ele2) => {
            ele2.style.height = `${maxHeight}px`;
          });
        });
      });
    },
    inViewAnimation() {
      const target = document.querySelectorAll(".js-fade");
      const options = {
        root: null,
        rootMargin: "-30% 0px",
        threshold: 0,
      };
      const callback = (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(v);
          }
        });
      };
      const observer = new IntersectionObserver(callback, options);

      target.forEach((ele) => {
        observer.observe(ele);
      });
    },
    headerHamburger() {
      const $hamburger = document.querySelector(".header-hamburger");
      const $nav = document.querySelector(".header-nav");
      const $header = document.querySelector(".header");
      const $container = document.querySelector(".container");
      let scrollTopNow;

      const fixedOnContainer = () => {
        scrollTopNow = window.scrollY;
        $container.style.position = "fixed";
        $container.style.width = "100%";
        $container.style.top = -1 * scrollTopNow;
        $container.style.left = 0;
        document.body.classList.add(f);
      };
      const fixedOffContainer = () => {
        $container.style.position = "static";
        document.body.classList.remove(f);
        window.scrollTo({ top: scrollTopNow });
      };

      if ($hamburger) {
        $hamburger.addEventListener("click", (e) => {
          e.currentTarget.classList.toggle(a);
          $header.classList.toggle(a);
          if ($nav.classList.contains(a)) {
            $nav.classList.remove(v);
            $nav.classList.remove(a);
            fixedOffContainer();
          } else {
            fixedOnContainer();
            $nav.classList.add(a);
            setTimeout(() => {
              $nav.classList.add(v);
            });
          }
        });
      }
    },
    headerScroll() {
      let header = document.querySelector(".header");
      let timer, flag;

      let set_position = 0;
      window.addEventListener("scroll", function () {
        let thisScroll = document.documentElement.scrollTop;

        if (thisScroll === 0 && flag) {
          header.classList.remove("is-on");
          flag = false;
        } else if (thisScroll > 0 && !flag) {
          header.classList.add("is-on");
          flag = true;
        }

        set_position = thisScroll;
      });
    },
    headerMenu() {
      // カレント
      //$('.js-megaMenu-btn').((idx, ele) => {
      document.querySelectorAll(".js-megaMenu-btn").forEach((ele) => {
        let $href = ele.getAttribute("href");
        if (FUNCTIONS.va.pathname.startsWith($href)) {
          ele.classList.add("is-current");
        }
      });
      document
        .querySelectorAll(".header-nav-main-li-a,.header-nav-sub-li-a")
        .forEach((link) => {
          link.addEventListener("mouseenter", () => {
            document.querySelector(".header").classList.add("hovered");
          });
          link.addEventListener("mouseleave", () => {
            document.querySelector(".header").classList.remove("hovered");
          });
        });

		let interval_count = 10;
		const interval = setInterval(() => {
			const inputElement = document.querySelector("#gsc-iw-id2");
			const hoverElement = document.querySelector("#___gcse_1");
			const headerElement = document.querySelector("header");
			const searchInput = document.querySelector("#gsc-i-id2");
	
			if (inputElement && hoverElement && headerElement && searchInput) {
				hoverElement.addEventListener("mouseenter", () => {
					inputElement.classList.add("is-active");
				});
	
				// header からホバーが外れたときに削除（検索ボックスにフォーカスがある場合は除外）
				headerElement.addEventListener("mouseleave", () => {
					if (document.activeElement !== searchInput) {
						inputElement.classList.remove("is-active");
					}
				});
	
				// 検索ボックスにフォーカスしたときも is-active を維持
				searchInput.addEventListener("focus", () => {
					inputElement.classList.add("is-active");
				});
	
				// 検索ボックスからフォーカスが外れたときに削除
				searchInput.addEventListener("blur", () => {
					inputElement.classList.remove("is-active");
				});
	
				clearInterval(interval);
			} else if (interval_count <= 0) {
				clearInterval(interval);
			} else {
				interval_count--;
			}
		}, 500);
    },
    headerMegamenu() {
      // メガメニュー表示／非表示
      let megaMenu = document.querySelectorAll(".js-megaMenu-btn");
      megaMenu.forEach((ele) => {
        ele.addEventListener("click", (e) => {
          document.querySelector(".header").classList.toggle("menuToggle");
          document
            .querySelectorAll(".header-nav-main-item>.__link")
            .forEach((ele2) => {
              if (ele2 !== e.currentTarget) {
                ele2.classList.remove(a);
              }
            });
          document.querySelectorAll(".js-megaMenu-block").forEach((ele2) => {
            if (
              ele2.getAttribute("data-name") !==
              e.currentTarget.getAttribute("data-name")
            ) {
              ele2.classList.remove(a);
            }
          });
          e.currentTarget.classList.toggle(a);
          if (e.currentTarget.getAttribute("data-name")) {
            let thisName = e.currentTarget.getAttribute("data-name");
            let thisMegaMenu = document.querySelector(
              '.js-megaMenu-block[data-name="' + thisName + '"]'
            );
            thisMegaMenu.classList.toggle(a);
          }
        });
      });
      // サブメニュー表示／非表示
      let mainMenu = document.querySelectorAll(
        ".header-megamenu-main > li .__link"
      );
      mainMenu.forEach((ele) => {
        if (!ele.closest(".js-subMenu-block")) {
          ele.addEventListener("mouseover", (e) => {
            let activeBtn = document.querySelectorAll(
              ".js-subMenu-btn.is-active"
            );
            let activeBlock = document.querySelectorAll(
              ".js-subMenu-block.is-active"
            );
            if (activeBtn.length) {
              activeBtn[0].classList.remove(a);
            }
            if (activeBlock.length) {
              activeBlock[0].classList.remove(a);
            }
            if (ele.classList.contains("js-subMenu-btn")) {
              ele.classList.add(a);
              let thisName = ele.getAttribute("data-name");
              let thisSubMenu = document.querySelector(
                '.js-subMenu-block[data-name="' + thisName + '"]'
              );
              thisSubMenu.classList.add(a);
              //  メニュー高さ調整
              let subHeight = thisSubMenu.clientHeight;
              let parentElement =
                ele.parentElement.parentElement.parentElement.parentElement;
              if (parentElement.classList.contains("header-megamenu-inner")) {
                if (parentElement.clientHeight < subHeight) {
                  parentElement.style.height = subHeight + "px";
                }
              }
            }
          });
          ele.addEventListener("focus", () => {
            let activeBtn = document.querySelectorAll(
              ".js-subMenu-btn.is-active"
            );
            let activeBlock = document.querySelectorAll(
              ".js-subMenu-block.is-active"
            );
            if (activeBtn.length) {
              activeBtn[0].classList.remove(a);
            }
            if (activeBlock.length) {
              activeBlock[0].classList.remove(a);
            }
            if (ele.classList.contains("js-subMenu-btn")) {
              ele.classList.add(a);
              let thisName = ele.getAttribute("data-name");
              let thisSubMenu = document.querySelector(
                '.js-subMenu-block[data-name="' + thisName + '"]'
              );
              thisSubMenu.classList.add(a);
            }
          });
        }
      });
      // クローズボタンでメガメニュー非表示
      let closeBtn = document.querySelectorAll(".js-megaMenu-close");
      closeBtn.forEach((ele) => {
        ele.addEventListener("click", (e) => {
          menuClose();
          document.querySelector(".header").classList.remove("hovered");
          document.querySelector(".header").classList.remove("menuToggle");
        });
      });
      // メガメニュー内aタグ・buttonタグ選択時escキーで閉じる
      let megahead = document.querySelectorAll(
        ".header-nav-main a,.header-nav-main button"
      );
      megahead.forEach((ele) => {
        ele.addEventListener("keydown", (e) => {
          // ESCキーでメガメニューを閉じる
          if (e.keyCode === 27) {
            menuClose();
          }
        });
      });
      // サブメニュー内をクリックしたらメニュー閉じる
      let subMenuLink = document.querySelectorAll(".header-megamenu-sub a");
      subMenuLink.forEach((ele) => {
        ele.addEventListener("click", () => {
          menuClose();
        });
      });
      // <PC>オーバーレイをホバーしたらメニュー非表示
      let megamenuoverlay = document.querySelectorAll(
        ".header-megamenu-overlay"
      );
      megamenuoverlay.forEach((ele) => {
        ele.addEventListener("mouseover", (e) => {
          menuClose();
          document.querySelector(".header").classList.remove("hovered");
          document.querySelector(".header").classList.remove("menuToggle");
        });
      });
      // <PC>サブメニュー閉じる
      document
        .querySelectorAll(".header-megamenu-main, .header-megamenu-head")
        .forEach((ele) => {
          ele.addEventListener("mouseover", function (e) {
            let target = e.target;
            if (!target.closest(".header-megamenu-main li")) {
              let activeSub = document.querySelector(
                ".js-subMenu-block.is-active"
              );
              if (
                activeSub &&
                !target.closest(".js-subMenu-btn, .js-subMenu-block")
              ) {
                activeSub.classList.remove(a);
                document
                  .querySelector(".js-subMenu-btn.is-active")
                  .classList.remove(a);
              }
            }
          });
        });

      // <SP>メガメニュー開閉
      let spMegaMenu = document.querySelectorAll("button.js-megaMenu-btn.__sp");
      spMegaMenu.forEach((ele) => {
        ele.addEventListener("click", (e) => {
          let thisName = ele.getAttribute("data-name");
          let thisMegaMenu = document.querySelector(
            '.js-megaMenu-block[data-name="' + thisName + '"]'
          );
          ele.classList.toggle(a);
          thisMegaMenu.classList.toggle(a);
        });
      });
      // サブメニュー開閉
      let spSubMenu = document.querySelectorAll("button.js-subMenu-btn");
      spSubMenu.forEach((ele) => {
        ele.addEventListener("click", (e) => {
          let thisName = ele.getAttribute("data-name");
          let thisSubMenu = document.querySelector(
            '.js-subMenu-block[data-name="' + thisName + '"]'
          );
          ele.classList.toggle(a);
          thisSubMenu.classList.toggle(a);
        });
      });
      // 全て閉じる
      const menuClose = () => {
        let activeBtn = document.querySelectorAll(".js-megaMenu-btn.is-active");
        let activeBlobck = document.querySelectorAll(
          ".js-megaMenu-block.is-active"
        );
        let activeSubBtn = document.querySelectorAll(
          ".js-subMenu-btn.is-active"
        );
        let activeSubBlock = document.querySelectorAll(
          ".js-subMenu-block.is-active"
        );
        if (activeBtn.length) {
          activeBtn[0].classList.remove(a);
        }
        if (activeBlobck.length) {
          activeBlobck[0].classList.remove(a);
        }
        if (activeSubBtn.length) {
          activeSubBtn[0].classList.remove(a);
        }
        if (activeSubBlock.length) {
          activeSubBlock[0].classList.remove(a);
        }
      };
    },
    fileSize() {
      const bytesToSize = (bytes) => {
        var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
        if (bytes === 0) {
          return "n/a";
        }
        var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
        if (i === 0) {
          return bytes + " " + sizes[i];
        }
        return (bytes / Math.pow(1024, i)).toFixed(1) + " " + sizes[i];
      };
      if (document.querySelectorAll(".js-fileSize").length) {
        document
          .querySelectorAll(".js-fileSize")
          .forEach(function (pdfElement) {
            pdfElement.textContent = bytesToSize(pdfElement.textContent);
          });
      }
    },
    removeElmIfEmpty() {
      // ＜ルート設定対応＞要素が空だったら削除
      const $eleList = document.querySelectorAll(".js-checkEmptyElm");
      $eleList.forEach((ele) => {
        if (!ele.textContent.length) {
          ele.remove();
        }
      });
    },
    removeBlockIfListEmpty() {
      // ＜ルート設定対応＞該当のリストにルート設定出力が0件の場合、指定する親ブロックごと削除する
      const $eleList = document.querySelectorAll(".js-checkEmptyList");
      if ($eleList) {
        $eleList.forEach((ele) => {
          if (!ele.getElementsByTagName("li")) {
            ele.closest(".js-checkEmptyList-wrap").remove();
          }
        });
      }
    },
    URLcurrent() {
      if (document.querySelector(".js-current")) {
        document.querySelectorAll(".js-current").forEach((item1) => {
          // 各要素の href を取得し、現在のページのURLに基づいた絶対パスに変換
          const linkPath = new URL(
            item1.getAttribute("href"),
            location.origin
          ).pathname.replace(/index\.html$/, "");
          const currentPath = location.pathname.replace(/index\.html$/, "");
          // 現在のページのパスがリンクのパスで始まる場合、is-activeを追加
          if (currentPath == linkPath) {
            item1.classList.add(a);
          }
        });
      }
    },
    casefixedBtn() {
      if (document.querySelector(".case-fixedBtn")) {
        if (document.querySelector(".inc_footer_link")) {
          let fixedBtn = document.querySelector(".case-fixedBtn");
          let footerLink = document.querySelector(".inc_footer_link");
          window.addEventListener("scroll", (e) => {
            let footerLinkRect = footerLink.getBoundingClientRect(); // 要素のビューポート内の位置を取得
            if (
              footerLinkRect.top <= window.innerHeight &&
              footerLinkRect.bottom >= 0
            ) {
              fixedBtn.classList.add("is-hidden");
            } else {
              fixedBtn.classList.remove("is-hidden");
            }
          });
        }
      }
    },
    loadDelayScript() {
      let _this = this;
      _this.accordion();
      _this.tabSwitch();
      _this.easeScroll();
      _this.easeScrollHash();
      _this.pageTop();
      _this.footerAccordion();
      _this.setModal();
      _this.matchHeight();
      _this.inViewAnimation();
      _this.headerHamburger();
      _this.headerScroll();
      _this.headerMenu();
      _this.headerMegamenu();
      _this.fileSize();
      _this.removeElmIfEmpty();
      _this.removeBlockIfListEmpty();
      _this.URLcurrent();
      _this.casefixedBtn();

      let resizeTime = 0;
      window.addEventListener("resize", () => {
        clearTimeout(resizeTime);
        resizeTime = setTimeout(() => {
          _this.matchHeight();
        }, 300);
      });
    },
  };

  document.addEventListener("DOMContentLoaded", () =>
    FUNCTIONS.localDecision()
      ? FUNCTIONS.localLoading()
      : FUNCTIONS.loadDelayScript()
  );
})();
